module.exports = __webpack_public_path__ + "public/files/img/5.afa5b60c.png";